import { Directive, HostListener, Input, NgModule } from "@angular/core";

// Shim mínimo para substituir `ngx-page-scroll` (módulo antigo não compatível).
// Hoje o projeto usa só o atributo `pageScroll` em um <a href="#...">.
@Directive({
  selector: "[pageScroll]",
})
export class PageScrollDirective {
  @Input() pageScrollOffset?: number | string;

  @HostListener("click", ["$event"])
  onClick(_event: MouseEvent): void {
    // No-op: deixa o comportamento padrão do anchor acontecer.
    // (O smooth scroll é um "nice to have" e pode ser refeito depois.)
  }
}

@NgModule({
  declarations: [PageScrollDirective],
  exports: [PageScrollDirective],
})
export class NgxPageScrollModule {}


